import { CourseStatus, CourseStatusColors } from './constants';
import { type ICourse } from 'src/models';
import Chip from '@material-ui/core/Chip';
import SecureLS from 'secure-ls';
import moment from 'moment';

export const secureLocalStorage = new SecureLS({ encodingType: 'aes' });

export function getCourseStatus(course: ICourse) {
	if (course.passed)
		return { color: CourseStatusColors.PASSED, label: CourseStatus.PASSED };
	else if (course.finished)
		return {
			color: CourseStatusColors.FINISHED,
			label: CourseStatus.FINISHED,
		};
	else if (course.started)
		return {
			color: CourseStatusColors.STARTED,
			label: CourseStatus.STARTED,
		};

	return {
		color: CourseStatusColors.NOT_STARTED,
		label: CourseStatus.NOT_STARTED,
	};
}

export function getCourseStatusChip(course: ICourse) {
	const status = getCourseStatus(course);

	return (
		<Chip
			label={status?.label}
			style={{
				background: status?.color,
				borderRadius: 4,
				color: '#fff',
				fontWeight: 500,
			}}
		/>
	);
}

export function getFilename(name: string) {
	return name.replace(/[^A-Z0-9]/gi, '_');
}

type by = 'sortOrder';

export function reorder(
	sections: any[],
	source: any,
	destination: any,
	by: by = 'sortOrder',
) {
	const _sections = Array.from(sections);
	const sourceIndex = _sections.findIndex(({ id }) => id == source);
	if (sourceIndex == destination) return _sections;
	const [removed] = _sections.splice(sourceIndex, 1);
	_sections.splice(destination, 0, removed);

	return _sections.map((section, index) => ({
		...section,
		[by]: index,
	}));
}

export function getTime(time: number) {
	// Hours, minutes and seconds
	const hrs = ~~(time / 3600);
	const mins = ~~((time % 3600) / 60);
	const secs = ~~time % 60;

	// Output like "1:01" or "4:03:59" or "123:03:59"
	let ret = '';

	if (hrs > 0) {
		ret += `${hrs}:${mins < 10 ? '0' : ''}`;
	}

	ret += `${mins}:${secs < 10 ? '0' : ''}`;
	ret += `${secs}`;

	return ret;
}

export function timeString(time: number): string {
	const hrs = ~~(time / 3600);
	const mins = ~~((time % 3600) / 60);
	let ret = '';

	if (hrs > 0) {
		ret += `${hrs}.${mins < 10 ? '0' : ''}`;
	}

	ret += `${mins}`;

	return `${ret} horas`;
}

export function getExamType(value: string): string {
	if (!value) return '';
	if (value == 'global') return 'GLOBAL';

	return 'PARCIAL';
}

export type formatType = 'time';

export function dateFormat(date: any, format?: formatType): string {
	if (format == 'time')
		return moment(date).format('YYYY/MM/DD H:mm:ss') || '';

	return moment(date).format('YYYY/MM/DD') || '';
}

export const initialsFor = (str?: string) => {
	if (!str) return '';
	let initials: any = str.match(/\b\w/g) || [];

	initials = (
		(initials?.shift ? initials?.shift() : '') + (initials?.pop ? initials?.pop() : '')
	).toUpperCase();

	return initials;
};

export function isDefaultDate(date: string) {
	if (!date) return true;

	return date.includes('0001-01-01');
}
